import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PosthogService } from '../../services/posthog.service';

@Component({
  selector: 'app-common-borderless',
  templateUrl: './borderless.component.html',
  imports: [CommonModule],
})
export class CommonBorderlessComponent implements OnInit {
  @Input() borderlessData: any;
  @Input() hasMarginBottom: any;
  borderLess: any;
  backgroundImageUrl: string = '';
  isMarginBottom: boolean = false;
  constructor(private posthogService: PosthogService) {
    this.subscriptions = [];
  }

  subscriptions: Subscription[];
  ngOnInit(): void {
    if (this.borderlessData != null) {
      this.backgroundImageUrl = `url(${this.borderlessData.image[1]?.fields?.file?.url})`;
      this.borderLess = this.borderlessData;
      this.isMarginBottom = this.hasMarginBottom;
    }
  }
  ngOnChanges(): void {
    if (this.borderlessData != null) {
      this.backgroundImageUrl = `url(${this.borderlessData.image[1]?.fields?.file?.url})`;
      this.borderLess = this.borderlessData;
      this.isMarginBottom = this.hasMarginBottom;
    }
  }

  /**
   * Tracks iOS app download button click
   */
  onAppStoreClick(url: string): void {
    this.posthogService.captureAppDownloadClick('ios', 'homepage', {
      buttonText: 'Download on App Store',
      destinationUrl: url
    });
  }

  /**
   * Tracks Android app download button click
   */
  onPlayStoreClick(url: string): void {
    this.posthogService.captureAppDownloadClick('android', 'homepage', {
      buttonText: 'Download on Play Store',
      destinationUrl: url
    });
  }
}
